import createVueComponent from '../createVueComponent';

const MinusCircle = createVueComponent('MinusCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
]);

export default MinusCircle;
